<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Создание паспорта') }}</h1>
    <div class="workroom-pg">
      <div class="bgw-pdg-20 passport-pg create">
        <h3 class="title">
          {{ $t('Паспорт') }}
        </h3>
        <div class="tab-main">
          <v-form
            class="form-ru"
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="createOopt"
          >
            <v-tabs
              background-color="white"
              left
              v-model="langTab"
            >
              <v-tab>Русский</v-tab>
              <v-tab>Кыргызча</v-tab>
              <v-tab>English</v-tab>
              <v-tab-item v-for="tabItem in tabItems" :key="tabItem.description">
                <div :class="{ 'form-label-copy': !tabItem.main }">
                  <v-row :class="{ invalid: $v.passport.name.$error && tabItem.main }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Наименование') }}: <span v-if="tabItem.main" class="asterix">*</span>
                        <fieldInfo :info="$t('Наименование')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="passport[tabItem.nameMain]" @copyText="copyText($event, tabItem.name)"/>
                      <v-text-field
                        v-model="passport[tabItem.name]"
                        required
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="tabItem.main" :class="{ invalid: $v.passport.category.$error }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>{{ $t('Категория') }}: <span class="asterix">*</span></v-label>
                      <fieldInfo :info="$t('Категория')"/>
                    </v-col>
                    <v-col class="input-field">
                      <div class="select-def">
                        <v-select
                          :items="fetchData.refCategory"
                          item-value="id"
                          item-text="transName"
                          v-model="passport.category"
                          outlined
                          dense
                          required
                          clearable
                        />
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="tabItem.main" :class="{ invalid: $v.passport.categoryIUCN.$error }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Категория МСОП') }}: <span class="asterix">*</span>
                        <fieldInfo :info="$t('Категория МСОП')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <div class="select-def">
                        <v-select
                          :items="fetchData.refCategoryIUCN"
                          item-value="id"
                          item-text="transName"
                          v-model="passport.categoryIUCN"
                          outlined
                          dense
                          required
                          clearable
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>
            </v-tabs>
            <div class="form-action">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                type="button"
                class="btn btn-default gray"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import OOPT from '@/model/oopt'
import fieldInfo from '@/components/app/fieldInfo'
import Copy from '@/components/oopt/Copy'
import { required } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'

export default {
  components: {
    fieldInfo,
    Copy
  },
  data: () => ({
    valid: true,
    fetchData: [],
    langTab: null,
    passport: {
      name: '',
      category: '',
      categoryIUCN: '',
      nameKg: '',
      nameEn: ''
    },
    rules: {
      passport: {
        name: { required },
        category: { required },
        categoryIUCN: { required }
      }
    },
    tabItems: [
      {
        main: true,
        name: 'name'
      },
      {
        main: false,
        nameMain: 'name',
        name: 'nameKg'
      },
      {
        main: false,
        nameMain: 'name',
        name: 'nameEn'
      }
    ],
    breadcrumbs: []
  }),
  mounted () {
    this.setLoading(true)
    OOPT.getOoptCreateFormData('oopt')
      .then((response) => {
        this.fetchData = response.data
        this.breadcrumbs = [
          { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
          { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
          { text: this.$i18n.t('Создание паспорта'), disabled: true }
        ]
        this.setLoading(false)
      })
      .catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
        this.setLoading(false)
      })
  },
  created () {
    this.scrollToTop()
  },
  validations () {
    return this.rules
  },
  methods: {
    ...mapMutations(['setLoading']),
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Создание ООПТ
    createOopt () {
      if (!this.validateForm()) {
        return
      }
      this.setLoading(true)

      OOPT.createOopt('oopt', this.passport)
        .then((response) => {
          if (response.status === 201) {
            this.$noty.success(this.$i18n.t('Успешно добавлено'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.setLoading(false)
            this.$router.push({
              name: 'MyOrganization'
            })
          }
        })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.validateForm()
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          this.setLoading(false)
        })
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'MyOrganization'
      })
    },
    // Копирование текста для мультиязычности
    copyText (title, refName) {
      this.passport[refName] = title
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
